module.exports = __webpack_public_path__ + "static/LocomotiveCMS-54ea0c0dbba9b72baf1d72d3751fa5a8.png";